// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SimilarStrollers__headline":"xg_a bhi_vn bhi_vf bhi_xb bhi_re bhi_tp bhi_qv"};